import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden m:block rounded-t-4xl overflow-hidden bg-merinos-50 absolute right-0 bottom-0 z-10 w-[496px]" }
const _hoisted_2 = {
  key: 0,
  class: "banner-info flex gap-x-1 justify-center bg-fir-900 text-left text-clay-200 font-bold text-sm py-4 whitespace-nowrap pl-10 relative"
}
const _hoisted_3 = { class: "relative w-full overflow-hidden" }
const _hoisted_4 = ["href", "title", "innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "p-10" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "uppercase text-sm text-merinos-400 font-black block mb-2" }
const _hoisted_9 = { class: "hidden m:block" }
const _hoisted_10 = { class: "rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-full cursor-pointer" }
const _hoisted_11 = { class: "flex items-center gap-x-2" }
const _hoisted_12 = { class: "mb-9" }
const _hoisted_13 = { class: "uppercase text-sm text-merinos-400 font-black block mb-2" }
const _hoisted_14 = { class: "hidden m:block" }
const _hoisted_15 = { class: "rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-full cursor-pointer" }
const _hoisted_16 = { class: "flex items-center space-x-2" }
const _hoisted_17 = { class: "flex justify-between items-center mb-9" }
const _hoisted_18 = { class: "uppercase text-sm text-merinos-400 font-black block" }
const _hoisted_19 = { class: "text-merinos-800 font-bold" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_23 = ["disabled", "href"]
const _hoisted_24 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_25 = { class: "flex justify-end mb-6" }
const _hoisted_26 = { class: "flex flex-col gap-y-4" }
const _hoisted_27 = { class: "flex gap-x-4 p-4 border border-merinos-100 bg-merinos-50 shadow-card rounded-3xl" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "flex flex-col gap-y-2" }
const _hoisted_30 = { class: "title-terra text-[20px] leading-6 font-medium font-serif" }
const _hoisted_31 = { class: "flex items-center gap-x-2 leading-6 font-medium text-merinos-800" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center gap-x-6"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex justify-between gap-x-6" }
const _hoisted_35 = { class: "px-6 py-4 rounded-t-3xl border border-merinos-100 shadow-card" }
const _hoisted_36 = { class: "flex items-center justify-center gap-x-4 text-center mb-5" }
const _hoisted_37 = { class: "text-merinos-400 text-sm uppercase font-black" }
const _hoisted_38 = { class: "text-merinos-800 font-bold leading-6" }
const _hoisted_39 = { class: "flex gap-x-4" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 2,
  disabled: "",
  class: "btn btn--terra flex-1"
}
const _hoisted_43 = { class: "z-2 relative" }
const _hoisted_44 = {
  key: 0,
  class: "wrapper fixed bottom-0 left-0 right-0 l:bottom-[unset] l:top-9 l:px-10"
}
const _hoisted_45 = { class: "relative wrapper w-full rounded-t-3xl bg-merinos-50 l:rounded-4xl l:shadow-card" }
const _hoisted_46 = {
  key: 0,
  class: "text-clay-200 bg-fir-900 text-sm px-7 py-2 l:hidden rounded-t-[20px]"
}
const _hoisted_47 = { class: "flex items-center gap-x-2 banner-info__marquee--desktop" }
const _hoisted_48 = ["href", "title", "innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "flex gap-x-8 py-4 px-4 l:px-16 l:justify-start l:gap-x-12 l:pr-[300px] items-center" }
const _hoisted_51 = { class: "hidden l:flex flex-row gap-x-6 items-center" }
const _hoisted_52 = { class: "uppercase text-merinos-400 text-xs font-black leading-4 l:text-sm" }
const _hoisted_53 = { class: "rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[320px] cursor-pointer" }
const _hoisted_54 = { class: "flex items-center gap-x-2" }
const _hoisted_55 = { class: "hidden l:flex flex-row gap-x-6 items-center" }
const _hoisted_56 = { class: "uppercase text-merinos-400 text-xs font-black leading-4 l:text-sm" }
const _hoisted_57 = { class: "rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[208px] cursor-pointer" }
const _hoisted_58 = { class: "flex items-center space-x-2" }
const _hoisted_59 = { class: "flex flex-wrap flex-col gap-y-1 l:flex-row l:gap-x-6 l:items-center" }
const _hoisted_60 = { class: "uppercase text-merinos-400 text-xs font-black leading-4 l:text-sm" }
const _hoisted_61 = { class: "flex text-merinos-800 font-bold leading-6" }
const _hoisted_62 = ["href"]
const _hoisted_63 = ["disabled"]

import { computed, ref, watch } from "vue";
import { format } from 'date-fns'
import { useBreakpoints, useIntersectionObserver, useScrollLock } from '@vueuse/core'
import Travelers from "./Travelers.vue";
import Dropdown from './Dropdown.vue';
import { objectToURLSearchParams } from "@studiometa/js-toolkit/utils";
import Alert from "../../molecules/Alert.vue";
import VueLoader from './Loader.vue';


export default {
  __name: 'SearchPrice',
  props: {
  id: Number,
  post: Object,
  trad: Array,
  from: Date,
  to: Date,
},
  setup(__props) {

const props = __props;
const object = props.post?.post.restrictions_per_dates;
let dates_with_tooltip = []

for(const restricted_dates in object) {
  dates_with_tooltip.push(
    {
      date: restricted_dates,
      type: 'dot',
      tooltip: [{ text: props.trad.min_nights }],
    }
  )
}


const markers = ref(dates_with_tooltip);

const searchParams = new URLSearchParams(
 decodeURIComponent(window.location.search)
);

const currentLocale = window.navigator.language;
const intl = new Intl.DateTimeFormat();
const post = ref(props.post);
const isLoading = ref(false);
const btnClicked = ref(false);
const stickyBtnClicked = ref(false);
const contentIsVibile = ref(false);
const staticDisabledDates = props.post?.post.unavailable_dates;
const disabledDates = ref([]);
disabledDates.value = Object.values(staticDisabledDates);

useIntersectionObserver(
  document.querySelector('main'),
  ([{ isIntersecting }]) => {
    contentIsVibile.value = isIntersecting
  },
  { threshold: 0.05, rootMargin: '0px' }
)

/**
 * Form state
 */
const date = ref([props.from, props.to]); // from-to

const TRAVELERS = ref([
  {
    label: props.trad.remote_adults,
    description: props.trad.remote_adults_legend,
    name: 'adult',
    value: Number(searchParams.get('adult') ?? 2),
  },
  {
    label: props.trad.remote_kids,
    description: props.trad.remote_kids_legend,
    name: 'child',
    value: Number(searchParams.get('child') ?? 0),
  },
  {
    label: props.trad.remote_babies,
    description: props.trad.remote_babies_legend,
    name: 'babies',
    value: Number(searchParams.get('babies') ?? 0),
  },
  {
    label: props.trad.remote_dogs,
    description: props.trad.remote_dogs_legend,
    name: 'dog',
    value: Number(searchParams.get('dog') ?? 0),
  },
]);

const isOpened = ref(false); // panel
const dropdownOpen = ref(false);
const stickyDropdownOpen = ref(false);
const dropdownActiveIndex = ref(0); // mobile dropdowns
const breakpoints = useBreakpoints({
  m: 1024,
  l: 1280
});
const isMobile = breakpoints.smaller('m')

const TODAY = new Date();

const isLocked = useScrollLock(document.body);

watch(isOpened, (shouldLock) => {
  isLocked.value = shouldLock;
})

const resetDropdown = () => {
  btnClicked.value = false;
  stickyBtnClicked.value = false;
};

const totalTravelers = computed(() => TRAVELERS.value.reduce(
  (accumulator, currentValue) => accumulator + currentValue.value,
  0
))

watch([date, TRAVELERS], update, { deep: true });

const amenitizUrl = computed(() => {
  if (date.value.length < 2) {
    return props.post?.post.amenitiz_url;
  }

  const url = new URL(`${props.post?.post.amenitiz_url}`)
  url.searchParams.append('start_date', format(new Date(date?.value?.[0]), 'yyyy-MM-dd'))
  url.searchParams.append('end_date', format(new Date(date?.value?.[1]), 'yyyy-MM-dd'))
  url.searchParams.append('adults', TRAVELERS.value[0].value)
  url.searchParams.append('children', TRAVELERS.value[1].value)

  return url.toString();
})

const onRangeStart = (value) => {
  disabledDates.value = Object.values(staticDisabledDates);
  let formatedDate = closestUnavailableDate(value);

  const indexOfObject = disabledDates.value.findIndex(object => {
    return object.includes(formatedDate);
  });
  if (indexOfObject != -1) {
    disabledDates.value.splice(indexOfObject, 1);
  }
}

const onRangeEnd = () => {
  dropdownOpen.value = false;

  if (totalTravelers.value < 1) {
    btnClicked.value = true;
  }
}

const onRangeEndSticky = () => {
  stickyDropdownOpen.value = false;

  if (totalTravelers.value < 1) {
    stickyBtnClicked.value = true;
  }
}

/**
 * Return the closest unavailable date in futur
 * @param  {String} givenDate selected Date
 * @return {Date}           next unavailable date
 */
function closestUnavailableDate(givenDate) {
  const formatedGivenDate = new Date(givenDate);
  const timeStampGivenDate = formatedGivenDate.getTime();

  for (let i = 0; i < staticDisabledDates.length; i++) {
    const date = new Date(staticDisabledDates[i].split('T')[0]);
    const dateTimeStamp = date.getTime();
    const difference = timeStampGivenDate - dateTimeStamp;
    if (difference <= 0) {
      return format(date, 'yyyy-MM-dd');
    }
  }

}

async function update() {
  if (date.value?.length <= 1) {
    return;
  }

  isLoading.value = true;

  const params = {
    id: props.id,
    from: format(new Date(date.value?.[0]), 'yyyy-MM-dd'),
    to: format(new Date(date.value?.[1]), 'yyyy-MM-dd'),
    adult: TRAVELERS.value[0].value,
    child: TRAVELERS.value[1].value,
    babies: TRAVELERS.value[2].value,
    dog: TRAVELERS.value[3].value,
  }

  const qs = objectToURLSearchParams(params);

  const dataTinyhouse = await fetch(`/wp-json/custom/tinyhouse?${qs.toString()}`, { method: 'POST' })
    .then((response) => response.json())

  post.value = dataTinyhouse;
  isLoading.value = false;
}

return (_ctx, _cache) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")
  const _component_VDropdown = _resolveComponent("VDropdown")
  const _component_VueSidePanel = _resolveComponent("VueSidePanel")

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        (post.value?.banner_info?.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                class: "absolute left-4 top-1/2 -translate-y-1/2 icon-img icon-img--sell",
                src: "data:image/svg+xml,%3Csvg%20width%3D%2221%22%20height%3D%2220%22%20viewBox%3D%220%200%2021%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_1172_9074%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2221%22%20height%3D%2220%22%3E%0A%3Crect%20x%3D%220.5%22%20width%3D%2220%22%20height%3D%2220%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url%28%23mask0_1172_9074%29%22%3E%0A%3Cpath%20d%3D%22M11.1868%2019.0417L2.16602%2010.0417V1.66667H10.5202L19.541%2010.6875L11.1868%2019.0417ZM11.2077%2016.5833L17.0827%2010.7083L9.79102%203.41667H3.91602V9.29167L11.2077%2016.5833ZM5.98097%206.77083C6.34045%206.77083%206.64518%206.64501%206.89518%206.39337C7.14518%206.14175%207.27018%205.83619%207.27018%205.47671C7.27018%205.11724%207.14436%204.8125%206.89272%204.5625C6.6411%204.3125%206.33554%204.1875%205.97606%204.1875C5.61658%204.1875%205.31185%204.31332%205.06185%204.56496C4.81185%204.81658%204.68685%205.12214%204.68685%205.48162C4.68685%205.8411%204.81267%206.14583%205.06431%206.39583C5.31593%206.64583%205.62149%206.77083%205.98097%206.77083Z%22%20fill%3D%22%23ABCBB2%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A"
              }, null, -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_3, [
                (post.value?.banner_info?.cta?.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: post.value?.banner_info?.cta?.url,
                      title: post.value?.banner_info?.cta?.title,
                      class: "banner-info__marquee--desktop hover:opacity-75 transition block",
                      innerHTML: post.value?.banner_info?.content
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "banner-info__marquee--desktop block",
                      innerHTML: post.value?.banner_info?.content
                    }, null, 8 /* PROPS */, _hoisted_5))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.trad.dates), 1 /* TEXT */),
            _createVNode(_component_VDropdown, {
              onClick: _cache[1] || (_cache[1] = $event => (dropdownOpen.value = true)),
              shown: dropdownOpen.value
            }, {
              popper: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(Alert, {
                    message: post.value?.datepicker_info?.content,
                    type: post.value?.datepicker_info?.type
                  }, null, 8 /* PROPS */, ["message", "type"]),
                  _createVNode(_component_VueDatePicker, {
                    modelValue: date.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((date).value = $event)),
                    markers: markers.value,
                    "disabled-dates": disabledDates.value,
                    "min-date": _unref(TODAY),
                    locale: _unref(currentLocale),
                    inline: "",
                    range: "",
                    onRangeStart: onRangeStart,
                    onRangeEnd: onRangeEnd,
                    "auto-apply": "",
                    "multi-calendars": "",
                    "month-change-on-scroll": false,
                    "enable-time-picker": false,
                    "prevent-min-max-navigation": "",
                    required: ""
                  }, {
                    "action-preview": _withCtx(() => _cache[17] || (_cache[17] = [])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "markers", "disabled-dates", "min-date", "locale"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[15] || (_cache[15] = _createElementVNode("svg", {
                      class: "mr-4",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("mask", {
                        id: "mask0_1666_6707",
                        style: {"mask-type":"alpha"},
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "24",
                        height: "24"
                      }, [
                        _createElementVNode("rect", {
                          width: "24",
                          height: "24",
                          fill: "#D9D9D9"
                        })
                      ]),
                      _createElementVNode("g", { mask: "url(#mask0_1666_6707)" }, [
                        _createElementVNode("path", {
                          d: "M3.5 21.5V4.50002H6.69233V2.38464H8.23075V4.50002H15.8077V2.38464H17.3076V4.50002H20.5V21.5H3.5ZM4.99997 20H19V10.3077H4.99997V20ZM4.99997 8.80774H19V5.99999H4.99997V8.80774Z",
                          fill: "currentColor"
                        })
                      ])
                    ], -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(date.value?.[0] ? _unref(intl).format(date.value[0]) : __props.trad.remote_start), 1 /* TEXT */),
                      _cache[14] || (_cache[14] = _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("mask", {
                          id: "mask0_1666_6711",
                          style: {"mask-type":"alpha"},
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "24",
                          height: "24"
                        }, [
                          _createElementVNode("rect", {
                            width: "24",
                            height: "24",
                            fill: "#D9D9D9"
                          })
                        ]),
                        _createElementVNode("g", { mask: "url(#mask0_1666_6711)" }, [
                          _createElementVNode("path", {
                            d: "M14.0481 17.6538L12.9942 16.5692L16.8135 12.75H4.2981V11.25H16.8135L12.9942 7.43079L14.0481 6.34619L19.7019 12L14.0481 17.6538Z",
                            fill: "#A99982"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createElementVNode("span", null, _toDisplayString(date.value?.[1] ? _unref(intl).format(date.value[1]) : __props.trad.remote_in), 1 /* TEXT */)
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("svg", {
                      class: "ml-4",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "#C3B6A6"
                      }),
                      _createElementVNode("path", {
                        d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                        fill: "#594631"
                      })
                    ], -1 /* HOISTED */))
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["shown"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(__props.trad.remote_travelers), 1 /* TEXT */),
            _createVNode(_component_VDropdown, {
              shown: btnClicked.value,
              onHide: resetDropdown
            }, {
              popper: _withCtx(() => [
                _createVNode(Travelers, {
                  travelers: TRAVELERS.value,
                  post: post.value,
                  trad: __props.trad,
                  total: totalTravelers.value
                }, null, 8 /* PROPS */, ["travelers", "post", "trad", "total"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[18] || (_cache[18] = _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("mask", {
                          id: "mask0_1666_6755",
                          style: {"mask-type":"alpha"},
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "24",
                          height: "24"
                        }, [
                          _createElementVNode("rect", {
                            width: "24",
                            height: "24",
                            fill: "#D9D9D9"
                          })
                        ]),
                        _createElementVNode("g", { mask: "url(#mask0_1666_6755)" }, [
                          _createElementVNode("path", {
                            d: "M16.9422 14.3077C16.3191 14.3077 15.7884 14.0884 15.3499 13.65C14.9114 13.2115 14.6922 12.6807 14.6922 12.0577C14.6922 11.4346 14.9114 10.9038 15.3499 10.4654C15.7884 10.0269 16.3191 9.80768 16.9422 9.80768C17.5653 9.80768 18.096 10.0269 18.5345 10.4654C18.9729 10.9038 19.1922 11.4346 19.1922 12.0577C19.1922 12.6807 18.9729 13.2115 18.5345 13.65C18.096 14.0884 17.5653 14.3077 16.9422 14.3077ZM12.1922 19.3077V18.1577C12.1922 17.8025 12.283 17.4765 12.4646 17.1795C12.6463 16.8825 12.9042 16.6688 13.2384 16.5385C13.82 16.2949 14.4218 16.1122 15.0438 15.9904C15.6658 15.8686 16.2986 15.8077 16.9422 15.8077C17.5728 15.8077 18.1994 15.8686 18.8219 15.9904C19.4444 16.1122 20.0524 16.2949 20.646 16.5385C20.9802 16.6688 21.2381 16.8825 21.4197 17.1795C21.6014 17.4765 21.6922 17.8025 21.6922 18.1577V19.3077H12.1922ZM9.80757 11.6923C8.84508 11.6923 8.02113 11.3496 7.33572 10.6642C6.65032 9.97876 6.30762 9.15481 6.30762 8.19233C6.30762 7.22983 6.65032 6.40588 7.33572 5.72048C8.02113 5.03506 8.84508 4.69235 9.80757 4.69235C10.7701 4.69235 11.594 5.03506 12.2794 5.72048C12.9648 6.40588 13.3075 7.22983 13.3075 8.19233C13.3075 9.15481 12.9648 9.97876 12.2794 10.6642C11.594 11.3496 10.7701 11.6923 9.80757 11.6923ZM2.30762 19.3077V16.9615C2.30762 16.541 2.44319 16.1375 2.71434 15.751C2.98549 15.3644 3.37427 15.0449 3.88067 14.7923C4.76143 14.3282 5.70569 13.9648 6.71344 13.702C7.72121 13.4391 8.75258 13.3077 9.80757 13.3077C10.2191 13.3077 10.6422 13.3314 11.0768 13.3789C11.5114 13.4263 11.9248 13.4975 12.3171 13.5923V14.5654C12.1479 14.6359 12.0069 14.7038 11.894 14.7691C11.7811 14.8344 11.6625 14.9062 11.5383 14.9846C11.2576 14.9205 10.9691 14.875 10.6729 14.8481C10.3768 14.8211 10.0883 14.8077 9.80757 14.8077C8.87295 14.8077 7.95437 14.9147 7.05182 15.1288C6.14925 15.3429 5.28578 15.6666 4.46142 16.1C4.26912 16.2025 4.11207 16.3368 3.99027 16.5029C3.86847 16.6689 3.80757 16.8628 3.80757 17.0846V17.8077H9.80757V19.3077H2.30762ZM9.80757 10.1923C10.3576 10.1923 10.8284 9.99649 11.2201 9.60483C11.6117 9.21316 11.8076 8.74233 11.8076 8.19233C11.8076 7.64233 11.6117 7.17149 11.2201 6.77983C10.8284 6.38816 10.3576 6.19233 9.80757 6.19233C9.25757 6.19233 8.78674 6.38816 8.39507 6.77983C8.0034 7.17149 7.80757 7.64233 7.80757 8.19233C7.80757 8.74233 8.0034 9.21316 8.39507 9.60483C8.78674 9.99649 9.25757 10.1923 9.80757 10.1923Z",
                            fill: "#A99982"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createElementVNode("span", null, _toDisplayString(totalTravelers.value > 0 ? `${totalTravelers.value} ${__props.trad.remote_travelers}` : __props.trad.remote_who), 1 /* TEXT */)
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "#C3B6A6"
                      }),
                      _createElementVNode("path", {
                        d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                        fill: "#594631"
                      })
                    ], -1 /* HOISTED */))
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["shown"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(__props.trad.from), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_19, _toDisplayString(isLoading.value ? '...' : post.value?.post.price) + " € / " + _toDisplayString(__props.trad.night), 1 /* TEXT */)
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                target: "_blank",
                href: amenitizUrl.value,
                class: "btn btn--terra w-full mb-6"
              }, _toDisplayString(__props.trad.cta_booking), 9 /* TEXT, PROPS */, _hoisted_20))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: isLoading.value || !post.value?.post.is_available,
                class: "btn btn--terra relative w-full mb-6"
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createVNode(VueLoader, { class: "absolute top-1/2 left-4 -mt-3" }),
                      _createTextVNode(" " + _toDisplayString(__props.trad.loading), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_21)),
          (post.value?.gift_url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                disabled: isLoading.value || !post.value?.post.is_available ? true : null,
                href: post.value?.gift_url,
                class: "btn btn--border-terra relative w-full"
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _createVNode(VueLoader, { class: "absolute top-1/2 left-4 -mt-3" }),
                      _createTextVNode(" " + _toDisplayString(__props.trad.loading), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(__props.trad.gift), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_23))
            : _createCommentVNode("v-if", true)
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createCommentVNode(" Mobile panel "),
          _createVNode(_component_VueSidePanel, {
            modelValue: isOpened.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((isOpened).value = $event)),
            class: "m:hidden",
            side: "bottom",
            "transition-name": "slide-bottom",
            "hide-close-btn": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = $event => (isOpened.value = false)),
                  class: "text-merinos-800 font-black tracking-wide pb-1 border-b border-[#DBC2B5] hover:text-merinos-500"
                }, _toDisplayString(__props.trad.close), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    class: "h-[74px] w-[74px] object-cover aspect-square rounded-2xl bg-merinos-100",
                    height: "74",
                    width: "74",
                    src: post.value?.post?.image ? post.value?.post.image : 'https://placehold.co/200x200',
                    alt: "Photo",
                    loading: "lazy"
                  }, null, 8 /* PROPS */, _hoisted_28),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(post.value?.post.post_title), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_31, [
                      _cache[20] || (_cache[20] = _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", null, [
                          _createElementVNode("path", {
                            d: "M10.0024 9.83329C10.4195 9.83329 10.7733 9.68714 11.0639 9.39483C11.3545 9.10251 11.4998 8.74781 11.4998 8.33073C11.4998 7.91365 11.3536 7.55981 11.0613 7.26923C10.769 6.97863 10.4143 6.83333 9.99723 6.83333C9.58015 6.83333 9.22632 6.97949 8.93573 7.27179C8.64514 7.56411 8.49984 7.91881 8.49984 8.3359C8.49984 8.75298 8.64599 9.10681 8.9383 9.3974C9.23061 9.68799 9.58532 9.83329 10.0024 9.83329ZM9.99982 18.173C7.82782 16.2585 6.20843 14.5037 5.14165 12.9086C4.07489 11.3135 3.5415 9.84538 3.5415 8.50415C3.5415 6.46826 4.18814 4.85442 5.4814 3.66265C6.77466 2.47088 8.2808 1.875 9.99982 1.875C11.7188 1.875 13.225 2.47088 14.5182 3.66265C15.8115 4.85442 16.4581 6.46826 16.4581 8.50415C16.4581 9.84538 15.9247 11.3135 14.858 12.9086C13.7912 14.5037 12.1718 16.2585 9.99982 18.173Z",
                            fill: "#806C4B"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createElementVNode("span", null, _toDisplayString(post.value?.post.city), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createVNode(Dropdown, {
                  label: __props.trad.remote_travelers,
                  description: totalTravelers.value > 0 ? `${totalTravelers.value} ${__props.trad.remote_travelers}` : __props.trad.remote_add_persons,
                  "is-expanded": dropdownActiveIndex.value === 2,
                  onOpen: _cache[3] || (_cache[3] = $event => (dropdownActiveIndex.value = 2))
                }, {
                  default: _withCtx(() => [
                    _createVNode(Travelers, {
                      travelers: TRAVELERS.value,
                      post: post.value,
                      trad: __props.trad
                    }, null, 8 /* PROPS */, ["travelers", "post", "trad"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "description", "is-expanded"]),
                _createVNode(Dropdown, {
                  label: __props.trad.dates,
                  "is-expanded": dropdownActiveIndex.value === 1,
                  onOpen: _cache[7] || (_cache[7] = $event => (dropdownActiveIndex.value = 1))
                }, {
                  description: _withCtx(() => [
                    (date.value?.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("span", null, _toDisplayString(_unref(format)(date.value[0], 'dd/MM')), 1 /* TEXT */),
                          _cache[21] || (_cache[21] = _createElementVNode("svg", {
                            class: "flex-1",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("g", null, [
                              _createElementVNode("path", {
                                d: "M14.0481 17.6538L12.9942 16.5692L16.8135 12.75H4.2981V11.25H16.8135L12.9942 7.43078L14.0481 6.34618L19.7019 12L14.0481 17.6538Z",
                                fill: "#A99982"
                              })
                            ])
                          ], -1 /* HOISTED */)),
                          _createElementVNode("span", null, _toDisplayString(_unref(format)(date.value[1], 'dd/MM')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(__props.trad.remote_add_dates), 1 /* TEXT */))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(Alert, {
                        message: post.value?.datepicker_info?.content,
                        type: post.value?.datepicker_info?.type
                      }, null, 8 /* PROPS */, ["message", "type"]),
                      _createVNode(_component_VueDatePicker, {
                        modelValue: date.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((date).value = $event)),
                        markers: markers.value,
                        "disabled-dates": disabledDates.value,
                        "min-date": _unref(TODAY),
                        locale: _unref(currentLocale),
                        inline: "",
                        range: "",
                        onRangeStart: onRangeStart,
                        onRangeEnd: onRangeEnd,
                        "auto-apply": "",
                        "month-change-on-scroll": false,
                        "enable-time-picker": false,
                        "prevent-min-max-navigation": "",
                        required: ""
                      }, {
                        "action-preview": _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              onClick: _cache[4] || (_cache[4] = $event => (date.value = [])),
                              class: "btn--link"
                            }, _toDisplayString(__props.trad.clear), 1 /* TEXT */),
                            _createElementVNode("button", {
                              onClick: _cache[5] || (_cache[5] = $event => (dropdownActiveIndex.value++)),
                              class: "btn btn--terra flex-1"
                            }, _toDisplayString(__props.trad.next), 1 /* TEXT */)
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "markers", "disabled-dates", "min-date", "locale"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "is-expanded"])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", _hoisted_37, _toDisplayString(__props.trad.remote_starting_from), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(isLoading.value ? __props.trad.loading : post.value?.post.price) + " € / " + _toDisplayString(__props.trad.night), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  (post.value?.gift_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: post.value?.gift_url,
                        class: "btn btn--border-terra flex-1"
                      }, _toDisplayString(__props.trad.gift_simple), 9 /* TEXT, PROPS */, _hoisted_40))
                    : _createCommentVNode("v-if", true),
                  (!isLoading.value && totalTravelers.value > 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        target: "_blank",
                        href: amenitizUrl.value,
                        class: "btn btn--terra flex-1"
                      }, _toDisplayString(post.value?.post.is_available ? __props.trad.cta_booking : __props.trad.cta_booking), 9 /* TEXT, PROPS */, _hoisted_41))
                    : (_openBlock(), _createElementBlock("button", _hoisted_42, _toDisplayString(isLoading.value ? __props.trad.loading : __props.trad.cta_booking), 1 /* TEXT */))
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_Transition, { name: "translate" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, [
                ((!_unref(isMobile) && contentIsVibile.value) || _unref(isMobile))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        (post.value?.banner_info?.content)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _cache[22] || (_cache[22] = _createElementVNode("svg", {
                                  width: "21",
                                  height: "20",
                                  viewBox: "0 0 21 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("g", null, [
                                    _createElementVNode("path", {
                                      d: "M11.1868 19.0417L2.16602 10.0417V1.66667H10.5202L19.541 10.6875L11.1868 19.0417ZM11.2077 16.5833L17.0827 10.7083L9.79102 3.41667H3.91602V9.29167L11.2077 16.5833ZM5.98097 6.77083C6.34045 6.77083 6.64518 6.64501 6.89518 6.39337C7.14518 6.14175 7.27018 5.83619 7.27018 5.47671C7.27018 5.11724 7.14436 4.8125 6.89272 4.5625C6.6411 4.3125 6.33554 4.1875 5.97606 4.1875C5.61658 4.1875 5.31185 4.31332 5.06185 4.56496C4.81185 4.81658 4.68685 5.12214 4.68685 5.48162C4.68685 5.8411 4.81267 6.14583 5.06431 6.39583C5.31593 6.64583 5.62149 6.77083 5.98097 6.77083Z",
                                      fill: "currentColor"
                                    })
                                  ])
                                ], -1 /* HOISTED */)),
                                (post.value?.banner_info?.cta?.url)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: post.value?.banner_info?.cta?.url,
                                      title: post.value?.banner_info?.cta?.title,
                                      class: "flex-1 hover:opacity-75 transition whitespace-nowrap",
                                      innerHTML: post.value?.banner_info?.content
                                    }, null, 8 /* PROPS */, _hoisted_48))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "flex-1 whitespace-nowrap",
                                      innerHTML: post.value?.banner_info?.content
                                    }, null, 8 /* PROPS */, _hoisted_49))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, _toDisplayString(__props.trad.dates), 1 /* TEXT */),
                            _createVNode(_component_VDropdown, {
                              onClick: _cache[10] || (_cache[10] = $event => (stickyDropdownOpen.value = true)),
                              shown: stickyDropdownOpen.value
                            }, {
                              popper: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(Alert, {
                                    message: post.value?.datepicker_info?.content,
                                    type: post.value?.datepicker_info?.type
                                  }, null, 8 /* PROPS */, ["message", "type"]),
                                  _createVNode(_component_VueDatePicker, {
                                    modelValue: date.value,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((date).value = $event)),
                                    "min-date": _unref(TODAY),
                                    locale: _unref(currentLocale),
                                    markers: markers.value,
                                    "disabled-dates": disabledDates.value,
                                    inline: "",
                                    range: "",
                                    onRangeStart: onRangeStart,
                                    onRangeEnd: onRangeEndSticky,
                                    "auto-apply": "",
                                    "multi-calendars": "",
                                    "month-change-on-scroll": false,
                                    "enable-time-picker": false,
                                    "prevent-min-max-navigation": "",
                                    required: ""
                                  }, {
                                    "action-preview": _withCtx(() => _cache[26] || (_cache[26] = [])),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["modelValue", "min-date", "locale", "markers", "disabled-dates"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_53, [
                                  _cache[24] || (_cache[24] = _createElementVNode("svg", {
                                    class: "mr-4",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("mask", {
                                      id: "mask0_1666_6707",
                                      style: {"mask-type":"alpha"},
                                      maskUnits: "userSpaceOnUse",
                                      x: "0",
                                      y: "0",
                                      width: "24",
                                      height: "24"
                                    }, [
                                      _createElementVNode("rect", {
                                        width: "24",
                                        height: "24",
                                        fill: "#D9D9D9"
                                      })
                                    ]),
                                    _createElementVNode("g", { mask: "url(#mask0_1666_6707)" }, [
                                      _createElementVNode("path", {
                                        d: "M3.5 21.5V4.50002H6.69233V2.38464H8.23075V4.50002H15.8077V2.38464H17.3076V4.50002H20.5V21.5H3.5ZM4.99997 20H19V10.3077H4.99997V20ZM4.99997 8.80774H19V5.99999H4.99997V8.80774Z",
                                        fill: "currentColor"
                                      })
                                    ])
                                  ], -1 /* HOISTED */)),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("span", null, _toDisplayString(date.value?.[0] ? _unref(intl).format(date.value[0]) : 'Départ'), 1 /* TEXT */),
                                    _cache[23] || (_cache[23] = _createElementVNode("svg", {
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("mask", {
                                        id: "mask0_1666_6711",
                                        style: {"mask-type":"alpha"},
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }, [
                                        _createElementVNode("rect", {
                                          width: "24",
                                          height: "24",
                                          fill: "#D9D9D9"
                                        })
                                      ]),
                                      _createElementVNode("g", { mask: "url(#mask0_1666_6711)" }, [
                                        _createElementVNode("path", {
                                          d: "M14.0481 17.6538L12.9942 16.5692L16.8135 12.75H4.2981V11.25H16.8135L12.9942 7.43079L14.0481 6.34619L19.7019 12L14.0481 17.6538Z",
                                          fill: "#A99982"
                                        })
                                      ])
                                    ], -1 /* HOISTED */)),
                                    _createElementVNode("span", null, _toDisplayString(date.value?.[1] ? _unref(intl).format(date.value[1]) : 'Arrivée'), 1 /* TEXT */)
                                  ]),
                                  _cache[25] || (_cache[25] = _createElementVNode("svg", {
                                    class: "ml-4",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("rect", {
                                      width: "24",
                                      height: "24",
                                      rx: "12",
                                      fill: "#C3B6A6"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                                      fill: "#594631"
                                    })
                                  ], -1 /* HOISTED */))
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["shown"])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("span", _hoisted_56, _toDisplayString(__props.trad.remote_travelers), 1 /* TEXT */),
                            _createVNode(_component_VDropdown, {
                              shown: stickyBtnClicked.value,
                              onHide: resetDropdown
                            }, {
                              popper: _withCtx(() => [
                                _createVNode(Travelers, {
                                  travelers: TRAVELERS.value,
                                  post: post.value,
                                  trad: __props.trad,
                                  total: totalTravelers.value
                                }, null, 8 /* PROPS */, ["travelers", "post", "trad", "total"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("mask", {
                                        id: "mask0_1666_6755",
                                        style: {"mask-type":"alpha"},
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }, [
                                        _createElementVNode("rect", {
                                          width: "24",
                                          height: "24",
                                          fill: "#D9D9D9"
                                        })
                                      ]),
                                      _createElementVNode("g", { mask: "url(#mask0_1666_6755)" }, [
                                        _createElementVNode("path", {
                                          d: "M16.9422 14.3077C16.3191 14.3077 15.7884 14.0884 15.3499 13.65C14.9114 13.2115 14.6922 12.6807 14.6922 12.0577C14.6922 11.4346 14.9114 10.9038 15.3499 10.4654C15.7884 10.0269 16.3191 9.80768 16.9422 9.80768C17.5653 9.80768 18.096 10.0269 18.5345 10.4654C18.9729 10.9038 19.1922 11.4346 19.1922 12.0577C19.1922 12.6807 18.9729 13.2115 18.5345 13.65C18.096 14.0884 17.5653 14.3077 16.9422 14.3077ZM12.1922 19.3077V18.1577C12.1922 17.8025 12.283 17.4765 12.4646 17.1795C12.6463 16.8825 12.9042 16.6688 13.2384 16.5385C13.82 16.2949 14.4218 16.1122 15.0438 15.9904C15.6658 15.8686 16.2986 15.8077 16.9422 15.8077C17.5728 15.8077 18.1994 15.8686 18.8219 15.9904C19.4444 16.1122 20.0524 16.2949 20.646 16.5385C20.9802 16.6688 21.2381 16.8825 21.4197 17.1795C21.6014 17.4765 21.6922 17.8025 21.6922 18.1577V19.3077H12.1922ZM9.80757 11.6923C8.84508 11.6923 8.02113 11.3496 7.33572 10.6642C6.65032 9.97876 6.30762 9.15481 6.30762 8.19233C6.30762 7.22983 6.65032 6.40588 7.33572 5.72048C8.02113 5.03506 8.84508 4.69235 9.80757 4.69235C10.7701 4.69235 11.594 5.03506 12.2794 5.72048C12.9648 6.40588 13.3075 7.22983 13.3075 8.19233C13.3075 9.15481 12.9648 9.97876 12.2794 10.6642C11.594 11.3496 10.7701 11.6923 9.80757 11.6923ZM2.30762 19.3077V16.9615C2.30762 16.541 2.44319 16.1375 2.71434 15.751C2.98549 15.3644 3.37427 15.0449 3.88067 14.7923C4.76143 14.3282 5.70569 13.9648 6.71344 13.702C7.72121 13.4391 8.75258 13.3077 9.80757 13.3077C10.2191 13.3077 10.6422 13.3314 11.0768 13.3789C11.5114 13.4263 11.9248 13.4975 12.3171 13.5923V14.5654C12.1479 14.6359 12.0069 14.7038 11.894 14.7691C11.7811 14.8344 11.6625 14.9062 11.5383 14.9846C11.2576 14.9205 10.9691 14.875 10.6729 14.8481C10.3768 14.8211 10.0883 14.8077 9.80757 14.8077C8.87295 14.8077 7.95437 14.9147 7.05182 15.1288C6.14925 15.3429 5.28578 15.6666 4.46142 16.1C4.26912 16.2025 4.11207 16.3368 3.99027 16.5029C3.86847 16.6689 3.80757 16.8628 3.80757 17.0846V17.8077H9.80757V19.3077H2.30762ZM9.80757 10.1923C10.3576 10.1923 10.8284 9.99649 11.2201 9.60483C11.6117 9.21316 11.8076 8.74233 11.8076 8.19233C11.8076 7.64233 11.6117 7.17149 11.2201 6.77983C10.8284 6.38816 10.3576 6.19233 9.80757 6.19233C9.25757 6.19233 8.78674 6.38816 8.39507 6.77983C8.0034 7.17149 7.80757 7.64233 7.80757 8.19233C7.80757 8.74233 8.0034 9.21316 8.39507 9.60483C8.78674 9.99649 9.25757 10.1923 9.80757 10.1923Z",
                                          fill: "#A99982"
                                        })
                                      ])
                                    ], -1 /* HOISTED */)),
                                    _createElementVNode("span", null, _toDisplayString(totalTravelers.value > 0 ? `${totalTravelers.value} ${__props.trad.remote_travelers}` : __props.trad.remote_who), 1 /* TEXT */)
                                  ]),
                                  _cache[28] || (_cache[28] = _createElementVNode("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("rect", {
                                      width: "24",
                                      height: "24",
                                      rx: "12",
                                      fill: "#C3B6A6"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                                      fill: "#594631"
                                    })
                                  ], -1 /* HOISTED */))
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["shown"])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("span", _hoisted_60, _toDisplayString(__props.trad.remote_starting_from), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_61, _toDisplayString(isLoading.value ? __props.trad.loading : post.value?.post.price) + " € / " + _toDisplayString(__props.trad.night), 1 /* TEXT */)
                          ]),
                          (!isLoading.value && totalTravelers.value > 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                target: "_blank",
                                href: amenitizUrl.value,
                                class: "hidden l:block btn btn--terra w-72 absolute right-2 top-1/2 transform -translate-y-1/2"
                              }, _toDisplayString(post.value?.post.is_available ? __props.trad.cta_booking : __props.trad.cta_booking), 9 /* TEXT, PROPS */, _hoisted_62))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[11] || (_cache[11] = _withModifiers($event => (stickyBtnClicked.value = true), ["prevent"])),
                                class: "hidden l:block btn btn--terra w-72 absolute right-2 top-1/2 transform -translate-y-1/2"
                              }, _toDisplayString(isLoading.value ? __props.trad.loading : __props.trad.cta_booking), 1 /* TEXT */)),
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = $event => (isOpened.value = true)),
                            class: "btn btn--terra l:hidden",
                            disabled: post.value?.post.is_available || !isLoading.value ? undefined : true
                          }, _toDisplayString(isLoading.value ? __props.trad.loading : __props.trad.cta_booking), 9 /* TEXT, PROPS */, _hoisted_63)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

}